import request from '../util/request'

export function wxband(params){
    return request.get('/system/wx/bind',params)
}

export function wxlogin(params){
    return request.get('/auth/loginWx',params)
}


// WEBPACK FOOTER //
// ./src/api/wxband.js